import { StrictMode, lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';
import { initTelegram } from './telegram';

const isAdmin = window.location.pathname === '/admin' || window.location.pathname.startsWith('/admin/');
const AdminApp = lazy(() => import('./admin/AdminApp').then(module => ({ default: module.AdminApp })));
if (!isAdmin) initTelegram();

const container = document.getElementById('root');
if (!container) throw new Error('missing #root');
createRoot(container).render(
  <StrictMode>
    <Suspense fallback={<div className="loading">加载中…</div>}>{isAdmin ? <AdminApp /> : <App />}</Suspense>
  </StrictMode>,
);
